export default function initBannerSignupValidation() {

}